import { render } from "./VehicleSecondForm.vue?vue&type=template&id=5ceed43a"
import script from "./VehicleSecondForm.vue?vue&type=script&lang=js"
export * from "./VehicleSecondForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__